












































import Vue from 'vue'
import webpack from 'webpack'
import LiftLinkBtn from '../../components/Domain/Lift/LiftLinkBtn.vue'
import LiftDescription from '../../components/Domain/Lift/LiftDescription.vue'
import BaseDescription from '../../components/base/BaseDescription.vue'
import LiftTitle from '../../components/Domain/Lift/LiftTitle.vue'
import TranslationDisplay from '../../components/base/Translation/TranslationDisplay.vue'

export default Vue.extend({
  name: 'PostList',
  components: { TranslationDisplay, LiftTitle, BaseDescription, LiftDescription, LiftLinkBtn },
  props: {
    posts: {
      type: Object,
      required: true
    }
  }
})
